import EditMembershipPlanComponent from 'components/membership/editMembershipPlan.tsx';

const AddMembershipPage = () => {
  return <EditMembershipPlanComponent />;
};

export default AddMembershipPage;
